import request from '~services/request';
export const CalendarService = {
    getAll: (startDay) => request.get('/calendar', { params: { startDay } }).then(response => response.data.data)
};
